export {default} from './CreatePromoteListing';



// WEBPACK FOOTER //
// ./src/pages/CreatePromoteListing/index.ts